// extracted by mini-css-extract-plugin
export default {"Outer":"Alert_Outer__G7tys"};